import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import echarts from 'echarts'
import '../static/theme/macarons.js'
import 'echarts/dist/extension/dataTool.js'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import '../static/theme/index.css'
import axios from 'axios'

import routes from './router'
import store from './store/'

import vueUtil from './assets/util/vue-util'
import VueAppend from 'vue-append'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(elementUI, { locale })
Vue.use(vueUtil)
Vue.use(VueAppend)

Vue.prototype.$axios = axios
Vue.prototype.$echarts = echarts
Vue.prototype.$filters = Vue.options.filters

const router = new VueRouter({
  // mode: 'history',
  // base: '/flutext/',
  routes
})

function onInput (el, ele, binding, vnode) {
  function handle () {
    // 只保留数字
    ele.value = ele.value.replace(/[^\d]/g, '')
  }

  return handle
}
const numberInput = {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
  }
}
// 自定义指令-只能输入数字
Vue.directive('number-input', numberInput)

// 验证邮箱的格式
Vue.prototype.validationEmail = function(name) {
  let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/

  if (name === '') {
    this.$message.error('Please input a valid email address to receive analysis results.')
  } else if (!reg.test(name)) {
    this.$message.error('Illegal email address!')
  } else {
    return true
  }
}

// 过滤器-下划线换空格
Vue.filter('underLineToSpace', function(str) {
  if (str && str !== '') {
    return str.replace(/_/g, ' ')
  } else {
    return ''
  }
})

// 过滤器-首字母大写
Vue.filter('initialCapitalization', function(str) {
  if (str === str.toUpperCase()) {
    return str
  }
  if (str && str !== '') {
    return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
  } else {
    return ''
  }
})

// 过滤器-限制字符串长度，超过则显示...
Vue.filter('formatString', function(str, lengthLimit) {
  if (str && str !== '' && str.length > lengthLimit) {
    return str.substring(0, lengthLimit) + '...'
  } else {
    return str
  }
})

new Vue({
  router,
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js